module.exports = __webpack_public_path__ + "static/media/viberForFormChecked.47ca04bd.svg";